import React, { useEffect, useRef, useState } from "react";
import { HotTable, HotColumn } from "@handsontable/react";
import Handsontable from "handsontable";
import "handsontable/dist/handsontable.min.css";
import { Button } from "primereact/button";
import { firstRowRenderer } from "../../../components/HandsonTable/handsontable";

export default function P210List({ dataTable, searchData }) {
    const hot = useRef(null);

    const [columnList, setColumnList] = useState(["routeNo", "areaOwner", "areaLocation", "areaSurface", "planNo", "asDesignPipeLength", "resultLength", "resultAccure", "approveDate", "duration", "datePlanBegin", "datePlanEnd", "dateActualBegin", "dateActualEnd", "acceptDate"]);

    const [data, setData] = useState([
        {
            routeNo: "เส้นทาง",
            areaOwner: "หน่วยงานเจ้าของพื้นที่",
            areaLocation: "สถานที่",
            areaSurface: "ผิวจราจร",
            planNo: "เลขที่ \n แบบแปลน",
            asDesignPipeLength: "ตามแบบ",
            resultLength: "ผลงานก่อสร้าง",
            resultAccure: "",
            approveDate: "วันที่ \n  อนุมัติเข้า",
            duration: "ระยะ \n เวลา \n (วัน)",
            datePlanBegin: "วันที่ทำการก่อสร้าง",
            datePlanEnd: "",
            dateActualBegin: "",
            dateActualEnd: "",
            acceptDate: "ตรวจรับงาน \n ครั้งสุดท้าย \n  วันที่",
        },
        {
            routeNo: "",
            areaOwner: "",
            areaLocation: "",
            areaSurface: "",
            planNo: "",
            asDesignPipeLength: "ความยาวท่อ (ม.)",
            resultLength: "ความยาวท่อ (ม.)",
            resultAccure: "",
            approveDate: "",
            duration: "",
            datePlanBegin: "ตามแผน",
            datePlanEnd: "",
            dateActualBegin: "ตามจริง",
            dateActualEnd: "",
            acceptDate: "",
        },
        {
            routeNo: "",
            areaOwner: "",
            areaLocation: "",
            areaSurface: "",
            planNo: "",
            asDesignPipeLength: "",
            resultLength: "สัปดาห์",
            resultAccure: "รวม",
            approveDate: "",
            duration: "",
            datePlanBegin: "เริ่มงาน",
            datePlanEnd: "สิ้นสุด",
            dateActualBegin: "เรื่องงาน",
            dateActualEnd: "แล้วเสร็จ",
            acceptDate: "",
        },
    ]);

    const [mergeCells, setMergeCells] = useState([
        { row: 0, col: 0, rowspan: 3, colspan: 1 },
        { row: 0, col: 1, rowspan: 3, colspan: 1 },
        { row: 0, col: 2, rowspan: 3, colspan: 1 },
        { row: 0, col: 3, rowspan: 3, colspan: 1 },
        { row: 0, col: 4, rowspan: 3, colspan: 1 },
        { row: 0, col: 5, rowspan: 1, colspan: 1 },
        { row: 1, col: 5, rowspan: 2, colspan: 1 },
        { row: 0, col: 6, rowspan: 1, colspan: 2 },
        { row: 1, col: 6, rowspan: 1, colspan: 2 },
        { row: 0, col: 8, rowspan: 3, colspan: 1 },
        { row: 0, col: 9, rowspan: 3, colspan: 1 },
        { row: 0, col: 10, rowspan: 1, colspan: 4 },
        { row: 1, col: 10, rowspan: 1, colspan: 2 },
        { row: 1, col: 12, rowspan: 1, colspan: 2 },
        { row: 0, col: 14, rowspan: 3, colspan: 1 },
    ]);

    useEffect(() => {
        HotSetting();
    }, [dataTable]);

    const HotSetting = () => {
        let newHdInfo = [...data];
        let newDataTable = [...dataTable];

        let newReadOnlyList = dataTable.map(() => []);
        newReadOnlyList.push([]);

        setData([...newHdInfo, ...newDataTable]);
    };

    const rendercolumns = () => {
        let columnData = [];
        columnList.forEach((item) => {
            columnData.push({ data: item });
        });
        return columnData;
    };

    return (
        <div>
            <HotTable
                ref={hot}
                data={data}
                columns={rendercolumns()}
                mergeCells={mergeCells}
                autoRowSize={false}
                autoColumnSize={true}
                height={"500px"}
                colWidths={[100, 200,300,100,100,100,100,100,100,100,100,100,100,100,270]}
                cells={(row, col) => {
                    const cellProperties = {};

                    /**
                     * Set Coloer Table
                     */
                    if (row < 3) {
                        cellProperties.renderer = firstRowRenderer; //Header Table
                    }

                    if (row > 2) {
                        cellProperties.className = " detail";
                    }

                    cellProperties.readOnly = true;
                    // }
                    // row -newReadOnlyList 1 == 2 row hot
                    // col -newReadOnlyList 0 == 4 col hot

                    // if(row > 1 && (col > 3 && col <=11 )){

                    //     if(readOnlyList && readOnlyList.length > 0 && row-1 >=0 && col-4 >=0 ){
                    //         if(readOnlyList[row-1][col-4]  && readOnlyList[row-1][col-4] === 'Y'){
                    //             cellProperties.readOnly = false;
                    //             cellProperties.className = ' detail_input'
                    //         }
                    //     }
                    // }

                    return cellProperties;
                }}
            ></HotTable>
        </div>
    );
}
